import * as React from 'react'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import { trackingEvents } from 'modules/core/lib/Tracking/events'
import i18n from 'modules/core/lib/i18n'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { useReportTracking } from 'modules/reports/hooks/useReportTracking'
import { translateAggregationFunction } from 'modules/reports/lib/Constants'
import { aggregationFunctions } from 'modules/reports/lib/fieldHelper'

interface Props {
  fieldType: FieldType
}

const AggregationOptions = ({ fieldType }: Props) => {
  const { form, field } = fieldType

  const { track } = useReportTracking()

  if (!field) return null

  const handleChange = () => {
    track(trackingEvents.reports.aggregationChanged, {
      aggregation: form.get('function').value,
      field: field.attributes.path,
    })
  }

  const options = aggregationFunctions(field).map((value) => ({
    value,
    label: translateAggregationFunction(value),
  }))

  return (
    <Select
      none={i18n.t('common.none')}
      label={i18n.t('custom_reports.ability_labels.aggregate_by')}
      field={form.get('function')}
      options={options}
      onChange={handleChange}
    />
  )
}

export default observer(AggregationOptions)
